// GENERATED by apps/platform/scripts/generate-trade-shows.mjs — do not edit by hand.
export const TRADE_SHOWS_SUMMARY = {"events":92,"planned":0,"generatedOn":"2026-10-08","priceCheckedOn":"2026-10-05"} as const
